import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URL} from 'src/app/tools/URL';

@Component({
  selector: 'denuncia-anonima-recomendacoes',
  templateUrl: './denuncia-anonima-recomendacoes.component.html',
  styleUrls: ['./denuncia-anonima-recomendacoes.component.css']
})
export class DenunciaAnonimaRecomendacoesComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  denunciaAnonima() {
    this.router.navigate([URL.DENUNCIA_ANONIMA]);
  }


}
